import { AudioChunk } from '../../state/entities/AudioChunk'
import { AudioBufferChunk } from '../../state/entities/AudioBufferChunk'

export function isAudioBufferChunk(chunk: AudioChunk): chunk is AudioBufferChunk {
  return chunk instanceof AudioBufferChunk
}
